export default {
    friendlyBat: {icon: 'mdi-bat', color: 'dark-grey', effect: [
        {name: 'currencyMiningScrapGain', type: 'mult', value: 1.25}
    ]},
    hammer: {icon: 'mdi-hammer', color: 'brown', effect: [
        {name: 'mining_craftingStation', type: 'keepUpgrade', value: true}
    ]},
    aluminiumBrick: {icon: 'mdi-wall', color: 'blue-grey', effect: [
        {name: 'mining_aluminiumCache', type: 'keepUpgrade', value: true},
        {name: 'mining_aluminiumHardening', type: 'keepUpgrade', value: true}
    ]},
    copperBrick: {icon: 'mdi-wall', color: 'orange', effect: [
        {name: 'mining_copperCache', type: 'keepUpgrade', value: true}
    ]},
    aluminiumHeap: {icon: 'mdi-dots-triangle', color: 'blue-grey', effect: [
        {name: 'mining_aluminiumTanks', type: 'keepUpgrade', value: true},
        {name: 'mining_aluminiumAnvil', type: 'keepUpgrade', value: true}
    ]},
    bomb: {icon: 'mdi-bomb', color: 'red', effect: [
        {name: 'mining_hullbreaker', type: 'keepUpgrade', value: true}
    ]},
    copperHeap: {icon: 'mdi-dots-triangle', color: 'orange', effect: [
        {name: 'mining_copperTanks', type: 'keepUpgrade', value: true}
    ]},
    radar: {icon: 'mdi-radar', color: 'light-green', effect: [
        {name: 'mining_depthDweller', type: 'keepUpgrade', value: true}
    ]},
    press: {icon: 'mdi-download', color: 'deep-purple', effect: [
        {name: 'mining_compressor', type: 'keepUpgrade', value: true}
    ]},
    cupboard: {icon: 'mdi-cupboard', color: 'brown', effect: [
        {name: 'mining_oreSlots', type: 'keepUpgrade', value: true}
    ]},
    catalyst: {icon: 'mdi-flask', color: 'teal', effect: [
        {name: 'mining_refinery', type: 'keepUpgrade', value: true}
    ]},
    jumprope: {icon: 'mdi-jump-rope', color: 'brown', effect: [
        {name: 'mining_aluminiumExpansion', type: 'keepUpgrade', value: true},
        {name: 'mining_copperExpansion', type: 'keepUpgrade', value: true}
    ]},
    bronzePickaxe: {icon: 'mdi-pickaxe', color: 'amber', effect: [
        {name: 'mining_graniteHardening', type: 'keepUpgrade', value: true}
    ]},
    oreShelf: {icon: 'mdi-window-closed', color: 'brown', effect: [
        {name: 'mining_oreShelf', type: 'keepUpgrade', value: true},
        {name: 'mining_tinCache', type: 'keepUpgrade', value: true}
    ]},
    coalBrick: {icon: 'mdi-wall', color: 'dark-grey', effect: [
        {name: 'mining_furnace', type: 'keepUpgrade', value: true}
    ]},
    washingMachine: {icon: 'mdi-washing-machine', color: 'skyblue', effect: [
        {name: 'mining_oreWashing', type: 'keepUpgrade', value: true}
    ]},
    openedGift: {icon: 'mdi-gift-open', color: 'blue', effect: [
        {name: 'mining_bronzeCache', type: 'keepUpgrade', value: true},
        {name: 'mining_ironCache', type: 'keepUpgrade', value: true}
    ]},
    magnet: {icon: 'mdi-magnet', color: 'red', effect: [
        {name: 'mining_ironExpansion', type: 'keepUpgrade', value: true},
        {name: 'mining_ironHardening', type: 'keepUpgrade', value: true},
        {name: 'mining_ironFilter', type: 'keepUpgrade', value: true}
    ]},
    copperPickaxe: {icon: 'mdi-pickaxe', color: 'orange', effect: [
        {name: 'mining_magnet', type: 'keepUpgrade', value: true},
        {name: 'mining_warehouse', type: 'keepUpgrade', value: true}
    ]},
    tinBucket: {icon: 'mdi-pail', color: 'grey', effect: [
        {name: 'mining_titaniumExpansion', type: 'keepUpgrade', value: true},
        {name: 'mining_titaniumCache', type: 'keepUpgrade', value: true}
    ]},
    honeyPot: {icon: 'mdi-pot', color: 'amber', effect: [
        {name: 'miningResinMax', type: 'base', value: 1}
    ]},
}
